<div class="modal right" id="userModal" tabindex="-1" role="dialog" aria-labelledby="userModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="userModalLabel" ng-if="!user.id">New User</h4>
                    <h4 id="userModalLabel" ng-if="user.id">Edit User</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="postForm(user)" class="form-horizontal allcp-form" autocomplete="off" ng-if="user">
										<h4 style="font-size:13px">User Info</h4>
										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="user.first_name" class="form-control input-md" placeholder="First Name" required>
													<label>First Name</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input type="text" ng-model="user.last_name" class="form-control input-md" placeholder="Last Name" required>
													<label>Last Name</label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<input type="email" autocomplete="disabled" ng-model="user.email" class="form-control input-md" placeholder="E-Mail" required>
											<label>E-Mail</label>
										</div>

										<div class="form-group floating">
											<input type="password" ng-required="!user.id" autocomplete="disabled" ng-model="user.password" class="form-control input-md" placeholder="*********" required>
											<label>Password</label>
										</div>

										<hr>
										<div class="form-group row">
											<label class="col-md-3 control-label">Permission </label>
											<div class="col-md-9">

												<div class="checkbox-custom mt10">
													<input type="checkbox"
														ng-model="user.authorization.maps"
														ng-checked="user.authorization.maps"
														ng-disabled="user.owner"
														id="maps">
													<label for="maps">Orders Management</label>
												</div>
												
												<div class="checkbox-custom mt10">
													<input type="checkbox"
														ng-model="user.authorization.customers"
														ng-checked="user.authorization.customers"
														ng-disabled="user.owner"
														id="customers">
													<label for="customers">Partner Management</label>
												</div>
												<div class="checkbox-custom mt10">
													<input type="checkbox"
														ng-model="user.authorization.users"
														ng-checked="user.authorization.users"
														ng-disabled="user.owner"
														id="users">
													<label for="users">User Management</label>
												</div>
												<div class="checkbox-custom mt10">
													<input type="checkbox"
														ng-model="user.authorization.reports"
														ng-checked="user.authorization.reports"
														ng-disabled="user.owner"
														id="reports">
													<label for="reports">Rapors</label>
												</div>
												<div class="checkbox-custom mt10">
													<input type="checkbox"
														ng-model="user.authorization.settings"
														ng-checked="user.authorization.settings"
														ng-disabled="user.owner"
														id="settings">
													<label for="settings">Setting</label>
												</div>
											</div>
										</div>
				
										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue" ng-disabled="loading">
													<span ng-if="!user.id">CREATE</span>
                    								<span ng-if="user.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
